import React, {
    createContext, memo, useContext, useMemo 
} from "react";
import PropTypes from "prop-types";
   
const InstanceContext = createContext("global.instance");

export const InstanceContextProvider = memo(({ instance, children }) => {
    return (
        <InstanceContext.Provider value={instance}>
            {children}
        </InstanceContext.Provider>
    );
});

InstanceContextProvider.defaultProps = {
    children: null,
    instance: undefined,
};

InstanceContextProvider.propTypes = {
    children: PropTypes.node,
    instance: PropTypes.string,
};

InstanceContextProvider.displayName = "InstanceContextProvider";

export const useInstanceContext = () => {
    const instance = useContext(InstanceContext);
    return useMemo(() => ({ instance }), [instance]);
};

export default InstanceContextProvider;
